// API Response Types
export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface PaginatedResponse<T = any> {
  success: boolean;
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
  };
}

// Models
export interface Restaurant {
  id: number;
  name: string;
  slug: string;
  description?: string;
  cuisineTypes?: string[];
  address: string;
  area: string;
  city: string;
  latitude?: number;
  longitude?: number;
  phone: string;
  email?: string;
  website?: string;
  instagramUrl?: string;
  facebookUrl?: string;
  logoUrl?: string;
  coverImageUrl?: string;
  operatingHours?: Record<string, string>;
  isPremium: boolean;
  isVerified: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Offer {
  id: number;
  restaurantId: number;
  title: string;
  description: string;
  originalPrice?: number;
  offerPrice?: number;
  discountPercentage?: number;
  validFrom: Date;
  validTo: Date;
  daysApplicable?: string[];
  timeSlots?: string;
  termsConditions?: string;
  imageUrl?: string;
  cuisineType?: string;
  offerCategory?: string;
  maxRedemptions?: number;
  currentRedemptions: number;
  viewsCount: number;
  savesCount: number;
  isActive: boolean;
  isFeatured: boolean;
  sourceUrl?: string;
  verifiedBy?: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface OfferWithRestaurant {
  offer: Offer;
  restaurant: Restaurant;
}

export interface User {
  id: number;
  email: string;
  name: string | null;
  role: string;
}

export interface LoginResponse {
  token: string;
  user: User;
}

// Form Types
export interface CreateOfferInput {
  restaurantId: number;
  title: string;
  description: string;
  originalPrice?: number;
  offerPrice?: number;
  discountPercentage?: number;
  validFrom: string;
  validTo: string;
  daysApplicable?: string[];
  timeSlots?: string;
  termsConditions?: string;
  imageUrl?: string;
  cuisineType?: string;
  offerCategory?: string;
  isFeatured?: boolean;
}

export interface CreateRestaurantInput {
  name: string;
  slug: string;
  description?: string;
  cuisineTypes?: string[];
  address: string;
  area: string;
  phone: string;
  email?: string;
  website?: string;
  instagramUrl?: string;
  logoUrl?: string;
}

// Query Params
export interface OfferQueryParams {
  cuisine?: string;
  area?: string;
  minDiscount?: number;
  maxPrice?: number;
  date?: string;
  featured?: boolean;
  page?: number;
  limit?: number;
}

// Constants
export const CUISINE_TYPES = [
  'Italian',
  'Chinese',
  'Indian',
  'Continental',
  'Fast Food',
  'Desserts',
  'Beverages',
  'Multi-cuisine',
  'Mexican',
  'Thai',
] as const;

export const UDAIPUR_AREAS = [
  'City Palace',
  'Fateh Sagar',
  'Hiran Magri',
  'Sukhadia Circle',
  'Chetak Circle',
  'Bapu Bazaar',
  'Celebration Mall',
  'Durga Nursery',
  'Sector 11',
  'Sector 14',
  'University Road',
  'Ambamata',
] as const;

export const OFFER_CATEGORIES = [
  'discount',
  'bogo',
  'combo',
  'flat-price',
  'cashback',
] as const;
